"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonMixin = exports.Button = void 0;

var _composeReactRefs = _interopRequireDefault(require("@seznam/compose-react-refs"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _CheckmarkIcon = _interopRequireDefault(require("@artsy/icons/CheckmarkIcon"));

var _themes = require("../../themes");

var _Box = require("../Box");

var _Spinner = require("../Spinner");

var _Text = require("../Text");

var _tokens = require("./tokens");

var _excluded = ["children", "loading", "success", "size", "onClick", "alignItems", "justifyContent", "Icon"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = /*#__PURE__*/_react.default.forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
      loading = _ref.loading,
      success = _ref.success,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      onClick = _ref.onClick,
      _ref$alignItems = _ref.alignItems,
      alignItems = _ref$alignItems === void 0 ? "center" : _ref$alignItems,
      _ref$justifyContent = _ref.justifyContent,
      justifyContent = _ref$justifyContent === void 0 ? "center" : _ref$justifyContent,
      Icon = _ref.Icon,
      rest = _objectWithoutProperties(_ref, _excluded);

  var ref = (0, _react.useRef)(null);

  var handleClick = function handleClick(event) {
    if (!loading && onClick) {
      onClick(event);
    }
  };

  (0, _react.useEffect)(function () {
    if (loading && ref.current !== null) {
      var _ref$current;

      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.blur();
    }
  }, [loading]);
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    ref: (0, _composeReactRefs.default)(ref, forwardedRef),
    onClick: handleClick,
    size: size,
    loading: loading,
    success: success,
    tabIndex: loading ? -1 : 0,
    display: "inline-flex",
    alignItems: alignItems,
    justifyContent: justifyContent
  }, rest), loading && /*#__PURE__*/_react.default.createElement(_Spinner.Spinner, {
    size: size,
    color: "currentColor"
  }), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    lineHeight: 1,
    variant: getTextVariant(size),
    opacity: loading ? 0 : 1,
    display: "flex",
    alignItems: alignItems,
    justifyContent: justifyContent,
    width: "100%"
  }, !success && Icon && /*#__PURE__*/_react.default.createElement(Icon, {
    fill: "currentColor",
    mr: 0.5,
    "aria-hidden": "true"
  }), success && /*#__PURE__*/_react.default.createElement(_CheckmarkIcon.default, {
    fill: "currentColor",
    mr: 0.5,
    "aria-hidden": "true"
  }), children));
});

exports.Button = Button;
Button.displayName = "Button";
Button.defaultProps = {
  size: "large",
  variant: "primaryBlack"
};
var buttonMixin = (0, _styledComponents.css)(["cursor:pointer;position:relative;white-space:nowrap;font-weight:normal;text-align:center;border:1px solid;text-decoration:none;transition:color 0.25s ease,border-color 0.25s ease,background-color 0.25s ease,box-shadow 0.25s ease;"]);
exports.buttonMixin = buttonMixin;

var Container = _styledComponents.default.button.withConfig({
  displayName: "Button__Container",
  componentId: "sc-1bhxy1c-0"
})(["", ";", " ", " ", ";", ";"], buttonMixin, (0, _styledSystem.variant)({
  prop: "size",
  variants: _tokens.BUTTON_SIZES
}), function (props) {
  // Handle props driven states
  if (props.hover) {
    return (0, _styledSystem.variant)({
      variants: _tokens.BUTTON_VARIANTS.hover
    });
  }

  if (props.active) {
    return (0, _styledSystem.variant)({
      variants: _tokens.BUTTON_VARIANTS.active
    });
  }

  if (props.success) {
    return (0, _styledSystem.variant)({
      variants: _tokens.BUTTON_VARIANTS.success
    });
  }

  if (props.focus) {
    return (0, _styledComponents.css)(["outline:0;", ""], (0, _styledSystem.variant)({
      variants: _tokens.BUTTON_VARIANTS.focus
    }));
  }

  if (props.loading) {
    return (0, _styledComponents.css)(["cursor:auto;transition:none;pointer-events:none;", ""], (0, _styledSystem.variant)({
      variants: _tokens.BUTTON_VARIANTS.loading
    }));
  }

  if (props.disabled) {
    return (0, _styledComponents.css)(["pointer-events:none;", ""], (0, _styledSystem.variant)({
      variants: _tokens.BUTTON_VARIANTS.disabled
    }));
  }

  return (0, _styledSystem.variant)({
    variants: _tokens.BUTTON_VARIANTS.default
  });
}, function () {
  // Handle pseudo classes
  return (0, _styledComponents.css)(["@media ", "{&:hover{", "}}&:focus{outline:0;", "}&:active{", "}&:disabled{pointer-events:none;", "}"], _themes.THEME_V3.mediaQueries.hover, (0, _styledSystem.variant)({
    variants: _tokens.BUTTON_VARIANTS.hover
  }), (0, _styledSystem.variant)({
    variants: _tokens.BUTTON_VARIANTS.focus
  }), (0, _styledSystem.variant)({
    variants: _tokens.BUTTON_VARIANTS.active
  }), (0, _styledSystem.variant)({
    variants: _tokens.BUTTON_VARIANTS.disabled
  }));
}, _Box.boxMixin);

var getTextVariant = function getTextVariant(size) {
  if (typeof size === "string") {
    return _tokens.BUTTON_TEXT_SIZES[size];
  }

  if (Array.isArray(size)) {
    return size.map(function (s) {
      return _tokens.BUTTON_TEXT_SIZES[s];
    });
  }

  return _tokens.BUTTON_TEXT_SIZES.large;
};
//# sourceMappingURL=Button.js.map